import React from 'react'
import CustomDialog from '../../CustomDialog'
import { CardFooter } from '../../Card'
import GridContainer from '../../Grid/GridContainer'
import GridItem from '../../Grid/GridItem'
import SelectInput from '../../SelectInput'
import { useTranslation } from 'react-i18next'
import { DriverSelectModalProps } from '../interfaces'
import { useDriverSelectModal } from '../hooks/useDriverSelectModal'
import { CustomLoader } from '../../CustomLoader'
import { Color } from '../../../util'
import ButtonSpinner from '../../ButtonSpinner'
import { Driver } from '../../TransferAppointments/Traslado/EditTransferServiceDialog/interfaces'

export const DriverSelectModal = ({
  openDrivers,
  closeModalDrivers,
  onSaveDriver,
  driver,
}: DriverSelectModalProps) => {
  
  const { t } = useTranslation()

  const { drivers, handleSelectDriver, selectedDriver, isLoading } =
    useDriverSelectModal(driver)

  return (
    <CustomDialog
      maxWidth={'xs'}
      title={t('service.driver')}
      open={openDrivers}
      onClose={closeModalDrivers}
    >
      {isLoading ? (
        <CustomLoader />
      ) : (
        <>
          <div>
            <GridContainer className={'ps-child plan-form'}>
              <GridItem xs={12} sm={12} md={12} className="componentType">
                <SelectInput
                  data-testId={"driver__input"}
                  label={t('label.driver')}
                  id={"driver__input"}
                  elements={drivers}
                  onSelectedValue={handleSelectDriver}
                  value={selectedDriver}
                  getOptionSelected={(option:Driver) => option?.id || null}
                />
              </GridItem>
            </GridContainer>
          </div>
          <CardFooter className="schedule-form-submit buttonFooter">            
              <ButtonSpinner
                className="buttonPlusFooter"
                id={"saveDriver__btn"}
                onClick={() => onSaveDriver(selectedDriver)}
                color={Color.success}
                label={t('service.drivers.save.button')}
              />      
          </CardFooter>
        </>
      )}
    </CustomDialog>
  )
}
